import { useTheme } from '@/contexts/ThemeContext';
import { Typography } from '@/lib/base/text/typography';
import { sanitizeError } from '@/lib/utils/errors';

export default function FormErrors(props: {
  errors?: Array<{ param?: string; message: string }>;
  param?: string;
}) {
  const { isDark } = useTheme();

  if (!props.errors || !props.errors.length) {
    return null;
  }
  const errors = props.errors.filter(error =>
    props.param ? error.param === props.param : error.param == null
  );
  if (!errors.length) {
    return null;
  }

  const sectionColors = isDark
    ? 'bg-[var(--color-error-900)]/20 border border-[var(--color-error-500)]/30'
    : 'bg-[var(--color-error-50)] border border-[var(--color-error-200)]';

  const iconColors = isDark
    ? 'text-[var(--color-error-400)]'
    : 'text-[var(--color-error-500)]';
  return (
    <div className='mt-3'>
      {(() => {
        const seen = new Map<string, number>();
        return errors.map(e => {
          const base = `${e.param ?? ''}-${e.message}`;
          const count = seen.get(base) ?? 0;
          seen.set(base, count + 1);
          return (
            <div
              key={`${base}::${count}`}
              className={`flex items-start gap-2 p-3 ${sectionColors} rounded-lg backdrop-blur-sm`}
            >
              <div className='flex-shrink-0 mt-0.5'>
                <svg
                  className={`w-4 h-4 ${iconColors}`}
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                  />
                </svg>
              </div>
              <Typography color='error' className='text-sm font-medium'>
                {sanitizeError(e.message)}
              </Typography>
            </div>
          );
        });
      })()}
    </div>
  );
}

// eslint-disable-next-line react-refresh/only-export-components -- helper function co-located with component
export function hasErrors(props: {
  errors?: Array<{ param?: string; message: string }>;
  param?: string;
}) {
  if (!props.errors || !props.errors.length) {
    return false;
  }
  const errors = props.errors.filter(error =>
    props.param ? error.param === props.param : error.param == null
  );
  return errors.length > 0;
}
